import React, { useEffect, useState, useRef } from "react";
import {
  VStack,
  HStack,
  Text,
  Heading,
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  FormControl,
  FormLabel,
  Divider,
  Radio,
  RadioGroup,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  List,
  ListItem,
  Tooltip,
  IconButton,
  useToast,
  CircularProgress,
  Stack,
  Input,
  Center,
} from "@chakra-ui/react";
import { ArrowUpIcon, ArrowDownIcon } from "@chakra-ui/icons";
import {
  MdOutlineGetApp,
  MdFilterList,
  MdRefresh,
  MdCheck,
  MdOutlineImportExport,
} from "react-icons/md";
import { BsInfo } from "react-icons/bs";
import {
  descargarPlanificacion,
  getPlanificaciones,
  getClientes,
} from "./helpers/api.helper";
import { useSelector } from "react-redux";
import moment from "moment";
import { sortData } from "../../utils/sortData";
import LineaTiempoPlanificaciones from "./components/planificacion/LineaTiempoPlanificaciones";
import AgregarTnsNominales from "./components/historial/AgregarTnsNominales";
import AgregarNTPS from "./components/historial/AgregarNTPS";
import { regionalFormattingNumbers } from "../../utils/regionalFormattingNumbers";

const Historial = () => {
  // const { mobile } = props;
  const [planificaciones, setPlanificaciones] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [seleccionado, setSeleccionado] = useState();
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [filterBy, setFilterBy] = useState({
    set: "",
    cliente: "",
    inicio: "",
    fin: "",
  });
  const [sortField, setSortField] = useState();
  const [sortDirection, setSortDirection] = useState();
  const initialFocusRef = useRef();
  const { user } = useSelector((state) => state.user);
  const toast = useToast();

  const initData = async () => {
    setLoading(true);
    let res;
    res = await getPlanificaciones({ estado: "terminado" });

    if (res.status === 200) {
      setPlanificaciones(res.data);
    } else if (res.status === 204) {
      setLoading(false);
      return toast({
        title: "Exito",
        description: "Planificaciónes cargadas correctamente",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } else if (res.status === 400) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Error al cargar planificaciones",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    res = await getClientes();

    if (res.status === 200) {
      setClientes(res.data);
    } else {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Error al cargar clientes",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    setSeleccionado();
    setLoading(false);
  };

  const handleEtapas = (e) => {
    let total;

    let x = e.etapasSC?.filter((e) => e.numTotalEtapaSC === null);
    let y = e.etapasSC?.filter((e) => e.numTotalEtapaSC !== null);

    if (e.etapasSC) {
      if (x.length > 0) {
        let z = y[y.length - 1].numTotalEtapaSC;
        total = z + x.length;
      } else {
        total = e.etapasSC[e.etapasSC.length - 1].numTotalEtapaSC;
      }
    } else {
      total = 0;
    }
    return total;
  };
  const handleSets = (e) => {
    switch (e) {
      case "set1":
        return "Set 1";
      case "set2":
        return "Set 2";
      default:
        return "-";
    }
  };

  const filterStyle = (filterName) => ({
    // Aplicar un estilo diferente al filtro seleccionado
    backgroundColor:
      filterName === selectedFilter ? "lightblue" : "transparent",
  });

  const handleDownload = async (e) => {
    let response = await descargarPlanificacion({
      id: e.idPlanificacion,
      detallePlantas: e.detallePlantas || [],
      nombre: e.idPadlocacion,
    });

    const url = window.URL.createObjectURL(
      new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      })
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Historial-${e.idPadlocacion}.xlsx`);
    document.body.appendChild(link);
    link.click();
  };

  const handleTnsOperada = (planificacion) => {
    const consumidoTotalEtapas = planificacion.consumidoTotalEtapas;
    if (isNaN(consumidoTotalEtapas) || consumidoTotalEtapas === null) {
      let sumaDeLongitudes = 0;
      let totalSc;
      if (planificacion.etapasSC) {
        for (let i = 0; i < planificacion.etapasSC.length; i++) {
          if (
            planificacion.etapasSC[i].sandCubes &&
            planificacion.etapasSC[i].sandCubes.length > 0
          ) {
            sumaDeLongitudes += planificacion.etapasSC[i].sandCubes.length;
          }
        }

        totalSc = sumaDeLongitudes * 13.5;
      } else {
        return 0;
      }
      return regionalFormattingNumbers({ number: totalSc, digits: 0 });
    }
    return regionalFormattingNumbers({
      number: consumidoTotalEtapas,
      digits: 0,
    });
  };

  const showPlanificaciones = () => {
    if (Object.values(filterBy).every((value) => !value)) {
      return planificaciones;
    }
    return planificaciones.filter((planificacion) => {
      const { set, cliente, inicio, fin } = filterBy;

      return (
        (!set || planificacion.idSET === set) &&
        (!cliente || planificacion.cliente.nombreCliente === cliente) &&
        (!inicio || planificacion.fechaInicio <= inicio) &&
        (!fin || planificacion.fechaFinal >= fin)
      );
    });
  };
  const cleanFilter = () => {
    setFilterBy({
      set: "",
      cliente: "",
      estado: "",
      inicio: "",
      fin: "",
    });
  };
  const loadingtable = () => {
    return (
      <HStack w="100%" placeContent="center">
        <CircularProgress isIndeterminate color="brand.naranja" />
      </HStack>
    );
  };

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {}, [sortField, sortDirection]);

  return (
    <VStack w="100%" maxH="100vh">
      <HStack
        w="100%"
        bg="brand.fondos_secundario"
        justifyContent={"space-between"}
      >
        <HStack pl={5}>
          <Heading
            fontWeight="medium"
            size="xl"
            fontFamily="fonts.title"
            color="brand.gris_primario"
          >
            Historial
          </Heading>
          <Text fontSize="12px" placeSelf={"end"}>
            Listado de operaciones finalizadas{" "}
          </Text>
        </HStack>
        <HStack spacing={7} pr={5}>
          <LineaTiempoPlanificaciones
            planificaciones={showPlanificaciones()}
            type="historial"
          />

          <Popover isLazy>
            <PopoverTrigger>
              <IconButton
                icon={<MdFilterList fontSize="20px" />}
                bg={"brand.fondos_secundarios"}
                borderRadius="50%"
                color={"black"}
              />
            </PopoverTrigger>
            <PopoverContent>
              <PopoverArrow />
              <PopoverHeader>
                <Tooltip label="Limpiar filtro">
                  <IconButton
                    icon={<MdRefresh />}
                    onClick={cleanFilter}
                    variant="link"
                    justifySelf={"end"}
                  />
                </Tooltip>
              </PopoverHeader>
              <PopoverBody maxH={"sm"} overflowY={"auto"}>
                <Accordion allowToggle>
                  <AccordionItem>
                    <AccordionButton fontWeight={"bold"}>
                      Por Set
                    </AccordionButton>
                    <AccordionPanel>
                      <List spacing={2} cursor={"pointer"}>
                        <HStack>
                          {selectedFilter === "set1" && <MdCheck />}
                          <ListItem
                            style={filterStyle("set1")}
                            onClick={() => {
                              setFilterBy((prevstate) => ({
                                ...prevstate,
                                set: "set1",
                              }));
                              showPlanificaciones();
                              setSelectedFilter("set1");
                            }}
                          >
                            Set 1
                          </ListItem>
                        </HStack>
                        <HStack>
                          {selectedFilter === "set2" && <MdCheck />}
                          <ListItem
                            style={filterStyle("set2")}
                            onClick={() => {
                              setFilterBy((prevstate) => ({
                                ...prevstate,
                                set: "set2",
                              }));
                              setSelectedFilter("set2");
                              showPlanificaciones();
                            }}
                          >
                            Set 2
                          </ListItem>
                        </HStack>
                      </List>
                    </AccordionPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionButton fontWeight={"bold"}>
                      Estado
                    </AccordionButton>
                    <AccordionPanel>
                      <List spacing={1} cursor={"pointer"}>
                        <HStack>
                          {" "}
                          {selectedFilter === "activo" && <MdCheck />}
                          <ListItem
                            style={filterStyle("activo")}
                            onClick={() => {
                              setFilterBy((prevstate) => ({
                                ...prevstate,
                                estado: "activo",
                              }));
                              setSelectedFilter("activo");
                              showPlanificaciones();
                            }}
                          >
                            Activo
                          </ListItem>
                        </HStack>

                        <HStack>
                          {selectedFilter === "inactivo" && <MdCheck />}

                          <ListItem
                            style={filterStyle("inactivo")}
                            onClick={() => {
                              setFilterBy((prevstate) => ({
                                ...prevstate,
                                estado: "inactivo",
                              }));
                              setSelectedFilter("inactivo");
                              showPlanificaciones();
                            }}
                          >
                            Inactivo
                          </ListItem>
                        </HStack>
                        <HStack>
                          {selectedFilter === "proyectado" && <MdCheck />}

                          <ListItem
                            style={filterStyle("proyectado")}
                            onClick={() => {
                              setFilterBy((prevstate) => ({
                                ...prevstate,
                                estado: "proyectado",
                              }));
                              setSelectedFilter("proyectado");
                              showPlanificaciones();
                            }}
                          >
                            Proyectado
                          </ListItem>
                        </HStack>
                        <HStack>
                          {selectedFilter === "terminado" && <MdCheck />}

                          <ListItem
                            style={filterStyle("terminado")}
                            onClick={() => {
                              setFilterBy((prevstate) => ({
                                ...prevstate,
                                estado: "terminado",
                              }));
                              setSelectedFilter("terminado");
                              showPlanificaciones();
                            }}
                          >
                            Terminado
                          </ListItem>
                        </HStack>
                      </List>
                    </AccordionPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionButton fontWeight={"bold"}>
                      Cliente
                    </AccordionButton>
                    <AccordionPanel>
                      <List spacing={1} cursor={"pointer"}>
                        {clientes.map((cliente) => (
                          <HStack key={cliente.idCliente}>
                            {selectedFilter === cliente && <MdCheck />}
                            <ListItem
                              style={filterStyle(cliente)}
                              onClick={() => {
                                setFilterBy((prevstate) => ({
                                  ...prevstate,
                                  cliente: cliente.nombreCliente,
                                }));
                                setSelectedFilter(cliente);
                                showPlanificaciones();
                              }}
                            >
                              {cliente.nombreCliente}
                            </ListItem>
                          </HStack>
                        ))}
                      </List>
                    </AccordionPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionButton>
                      <HStack>
                        <Text fontWeight={"bold"}>Fecha inicio</Text>
                        <Input
                          type="date"
                          size="sm"
                          w={150}
                          onChange={(e) => {
                            setFilterBy((prevstate) => ({
                              ...prevstate,
                              inicio: e.target.value,
                            }));
                            showPlanificaciones();
                          }}
                          value={filterBy.inicio}
                        />
                      </HStack>
                    </AccordionButton>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionButton>
                      <HStack>
                        <Text fontWeight={"bold"}>Fecha fin</Text>
                        <Input
                          type="date"
                          size="sm"
                          w={150}
                          onChange={(e) => {
                            setFilterBy((prevstate) => ({
                              ...prevstate,
                              fin: e.target.value,
                            }));
                            showPlanificaciones();
                          }}
                          value={filterBy.fin}
                        />
                      </HStack>
                    </AccordionButton>
                  </AccordionItem>
                </Accordion>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </HStack>
      </HStack>
      <HStack
        w="100%"
        h={["lg", "xl", "2xl"]}
        py={-2}
        bg="brand.fondos_secundario"
        borderRadius={5}
      >
        <Stack h="100%" placeSelf="self-start">
          <TableContainer
            w={"100%"}
            overflowX={"auto"}
            overflowY="auto"
            h={"lg"}
          >
            <Table variant="simple" size="sm">
              <Thead>
                <Tr borderBottom="2px solid black">
                  <Th></Th>
                  <Th
                    _hover={{ cursor: "pointer" }}
                    onMouseEnter={() =>
                      (document.querySelector(".hover-icon").style.display =
                        "inline-block")
                    }
                    onMouseLeave={() =>
                      (document.querySelector(".hover-icon").style.display =
                        "none")
                    }
                  >
                    <span
                      className="sortable"
                      onClick={() => {
                        const { sortedData, direction } = sortData(
                          "idPadlocacion",
                          planificaciones
                        );
                        setSortField("idPadlocacion");
                        setSortDirection(direction);
                        setPlanificaciones(sortedData);
                      }}
                    >
                      Nombre
                      {sortDirection === "asc" &&
                        sortField === "idPadlocacion" && <ArrowUpIcon />}
                      {sortDirection === "des" &&
                        sortField === "idPadlocacion" && <ArrowDownIcon />}
                    </span>
                    <span className="hover-icon" style={{ display: "none" }}>
                      <MdOutlineImportExport />
                    </span>
                  </Th>
                  <Th
                    _hover={{ cursor: "pointer" }}
                    onMouseEnter={() =>
                      (document.querySelector(".hover-icon1").style.display =
                        "inline-block")
                    }
                    onMouseLeave={() =>
                      (document.querySelector(".hover-icon1").style.display =
                        "none")
                    }
                  >
                    <span
                      className="sortable"
                      onClick={() => {
                        const { sortedData, direction } = sortData(
                          "cliente.nombreCliente",
                          planificaciones
                        );
                        setSortField("cliente.nombreCliente");
                        setSortDirection(direction);
                        setPlanificaciones(sortedData);
                      }}
                    >
                      Cliente
                      {sortDirection === "asc" &&
                        sortField === "cliente.nombreCliente" && (
                          <ArrowUpIcon />
                        )}
                      {sortDirection === "des" &&
                        sortField === "cliente.nombreCliente" && (
                          <ArrowDownIcon />
                        )}
                    </span>
                    <span className="hover-icon1" style={{ display: "none" }}>
                      <MdOutlineImportExport />
                    </span>
                  </Th>
                  <Th
                    _hover={{ cursor: "pointer" }}
                    onMouseEnter={() =>
                      (document.querySelector(".hover-icon2").style.display =
                        "inline-block")
                    }
                    onMouseLeave={() =>
                      (document.querySelector(".hover-icon2").style.display =
                        "none")
                    }
                  >
                    <span
                      className="sortable"
                      onClick={() => {
                        const { sortedData, direction } = sortData(
                          "etapasTotalPad",
                          planificaciones
                        );
                        setSortField("etapas");
                        setSortDirection(direction);
                        setPlanificaciones(sortedData);
                      }}
                    >
                      Etapas
                      {sortDirection === "asc" && sortField === "etapas" && (
                        <ArrowUpIcon />
                      )}
                      {sortDirection === "des" && sortField === "etapas" && (
                        <ArrowDownIcon />
                      )}
                    </span>
                    <span className="hover-icon2" style={{ display: "none" }}>
                      <MdOutlineImportExport />
                    </span>
                  </Th>
                  <Th
                    _hover={{ cursor: "pointer" }}
                    onMouseEnter={() =>
                      (document.querySelector(".hover-icon3").style.display =
                        "inline-block")
                    }
                    onMouseLeave={() =>
                      (document.querySelector(".hover-icon3").style.display =
                        "none")
                    }
                  >
                    <span
                      className="sortable"
                      onClick={() => {
                        const { sortedData, direction } = sortData(
                          "idSET",
                          planificaciones
                        );
                        setSortField("etapas");
                        setSortDirection(direction);
                        setPlanificaciones(sortedData);
                      }}
                    >
                      SET
                      {sortDirection === "asc" && sortField === "idSET" && (
                        <ArrowUpIcon />
                      )}
                      {sortDirection === "des" && sortField === "idSET" && (
                        <ArrowDownIcon />
                      )}
                    </span>
                    <span className="hover-icon3" style={{ display: "none" }}>
                      <MdOutlineImportExport />
                    </span>
                  </Th>
                  <Th>WetSand</Th>
                  <Th>TNS Nominales</Th>
                  {(user.idRol === "admin" ||
                    user.idRol === "userMantenimiento" ||
                    user.idRol === "useFacturacion" ||
                    user.idRol === "gerencia" ||
                    user.idRol === "userHS" ||
                    user.idRol === "usuarioIT" ||
                    user.idRol === "coorOp") && <Th>TNS Certificadas</Th>}
                  {(user.idRol === "admin" ||
                    user.idRol === "userMantenimiento" ||
                    user.idRol === "useFacturacion" ||
                    user.idRol === "gerencia" ||
                    user.idRol === "userHS" ||
                    user.idRol === "usuarioIT" ||
                    user.idRol === "coorOp") && (
                    <Th>
                      NPT
                      <span style={{ textTransform: "lowercase" }}>s</span>
                    </Th>
                  )}
                </Tr>
              </Thead>
              {loading && (
                <Tbody>
                  <Tr>
                    <Td colSpan={9}>{loadingtable()}</Td>
                  </Tr>
                </Tbody>
              )}
              {!loading && planificaciones.length < 1 && (
                <Tbody>
                  <Tr key={1}>
                    <Td
                      colSpan={9}
                      textAlign="center"
                      fontWeight="bold"
                      color="brand.gris_primario"
                    >
                      No hay planificaciónes finalizadas
                    </Td>
                  </Tr>
                </Tbody>
              )}
              {!loading && (
                <Tbody textAlign="center">
                  {showPlanificaciones().map((ejemplo, index) => (
                    <Tr
                      key={index}
                      value={ejemplo.id}
                      onClick={() => {
                        setSeleccionado(ejemplo);
                      }}
                      _hover={{ cursor: "pointer" }}
                    >
                      <Td>
                        <RadioGroup value={seleccionado?.idPlanificacion}>
                          <Radio
                            value={ejemplo.idPlanificacion}
                            border="1px solid #9EAAB8"
                            colorScheme="blackAlpha"
                          />
                        </RadioGroup>
                      </Td>
                      <Td textOverflow="ellipsis">{ejemplo.idPadlocacion}</Td>
                      <Td>{ejemplo.cliente.nombreCliente}</Td>
                      <Td textAlign={"right"}>{handleEtapas(ejemplo)}</Td>
                      <Td>{handleSets(ejemplo.idSET)}</Td>
                      <Td>{ejemplo.dosificadora ? "SI" : "NO"}</Td>
                      <Td>{handleTnsOperada(ejemplo)}</Td>

                      <Td textAlign={"right"}>
                        {!ejemplo.tnsNominales &&
                        (user.idRol === "admin" ||
                          user.idRol === "userMantenimiento" ||
                          user.idRol === "useFacturacion" ||
                          user.idRol === "gerencia" ||
                          user.idRol === "userHS" ||
                          user.idRol === "coorOp") ? (
                          <AgregarTnsNominales
                            ejemplo={ejemplo}
                            initData={initData}
                          />
                        ) : (
                          ejemplo.tnsNominales
                        )}
                      </Td>
                      <Td textAlign={"right"}>
                        {" "}
                        {!ejemplo.npts &&
                        (user.idRol === "admin" ||
                          user.idRol === "userMantenimiento" ||
                          user.idRol === "useFacturacion" ||
                          user.idRol === "userHS" ||
                          user.idRol === "gerencia" ||
                          user.idRol === "coorOp") ? (
                          <AgregarNTPS ejemplo={ejemplo} initData={initData} />
                        ) : (
                          ejemplo.npts
                        )}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              )}
            </Table>
          </TableContainer>
        </Stack>
        {seleccionado && (
          <Card
            w={"100%"}
            bg="brand.layout"
            border="none"
            boxShadow="none"
            h={"lg"}
            placeSelf="self-start"
            variant={"outline"}
          >
            <CardHeader pb="unset">
              <HStack w="100%" justifyContent="space-between">
                <Heading
                  textColor="brand.azul_text"
                  size="sm"
                  fontWeight="semibold"
                >
                  {seleccionado.idPadlocacion.toUpperCase()}
                </Heading>
              </HStack>
            </CardHeader>
            <Divider pt={1} color="#EBEAEA" />
            <CardBody overflowY="auto" overflowX={"hidden"}>
              <HStack pb={1}>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">ID Pozo</FormLabel>
                  {seleccionado.pozos &&
                    seleccionado.pozos.map((e) => (
                      <Text fontSize="sm" key={e.idPozo}>
                        {e.nombrePozo}
                      </Text>
                    ))}
                </FormControl>

                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Etapas</FormLabel>
                  {seleccionado.pozos &&
                    seleccionado.pozos.map((e) => (
                      <Text fontSize="sm" key={e.idPozo}>
                        {e.numeroEtapasPozo}
                      </Text>
                    ))}
                </FormControl>

                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">DTM Completo</FormLabel>
                  {seleccionado.desMontTransp && <Text fontSize="sm">SI</Text>}
                  {!seleccionado.desMontTransp && <Text fontSize="sm">NO</Text>}
                </FormControl>
              </HStack>
              <Divider py={1} />
              <HStack py={1}>
                <FormControl alignSelf="start">
                  <FormLabel alignSelf="start" fontWeight="semibold">
                    Cliente
                  </FormLabel>
                  <Text fontSize="sm">
                    {seleccionado.cliente.nombreCliente}
                  </Text>
                </FormControl>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold" placeSelf="start">
                    Compañía de servicio
                  </FormLabel>
                  <Text fontSize="sm">{seleccionado.companiaServicio}</Text>
                </FormControl>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold" placeSelf="start">
                    Operadora
                  </FormLabel>
                  <Text fontSize="sm">
                    {seleccionado.cliente.nombreCliente}
                  </Text>
                </FormControl>
              </HStack>
              <Divider py={1} />
              <HStack py={1}>
                <FormControl>
                  <FormLabel fontWeight="semibold">Fecha Inicio</FormLabel>
                  <Text fontSize="sm">
                    {moment(seleccionado.fechaInicio).format("DD/MM/YYYY")}
                  </Text>
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="semibold">Fecha Fin</FormLabel>
                  <Text fontSize="sm">
                    {moment(seleccionado.fechaFinal).format("DD/MM/YYYY")}
                  </Text>
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="semibold">Fecha DTM</FormLabel>
                  <Text fontSize="sm">
                    {moment(seleccionado.fechaDTM).format("DD/MM/YYYY")}
                  </Text>
                </FormControl>
              </HStack>
              <Divider py={1} />
              <HStack pt={1}>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">
                    Area Hidrocarburifera
                  </FormLabel>
                  <Text fontSize="sm">
                    {seleccionado.nombreAreaHidrocarburifera}
                  </Text>
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="semibold"></FormLabel>
                  <HStack>
                    <Popover
                      initialFocusRef={initialFocusRef}
                      placement="bottom"
                      closeOnBlur={false}
                    >
                      <PopoverTrigger>
                        <Tooltip label="Descripcion">
                          <IconButton
                            icon={<BsInfo fontSize="24px" />}
                            variant="outline"
                            color="brand.azul_fondo"
                            placeItems="center"
                            size="sm"
                          />
                        </Tooltip>
                      </PopoverTrigger>
                      <PopoverContent>
                        <PopoverArrow />
                        <PopoverHeader>Descripción</PopoverHeader>
                        <PopoverCloseButton />
                        <PopoverBody>
                          {seleccionado.descripcionAreaHidrocarburifera}
                        </PopoverBody>
                      </PopoverContent>
                    </Popover>
                  </HStack>
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="semibold">Localizacion</FormLabel>
                  <Text fontSize="sm">{seleccionado.direccion}</Text>
                  <Text fontSize="sm">{seleccionado.ciudad}</Text>
                  <Text fontSize="sm">{seleccionado.provincia}</Text>
                </FormControl>
              </HStack>
              <Divider py={1} />
              <HStack pt={1}>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Malla</FormLabel>
                  {seleccionado.mallas?.map((malla) => (
                    <Text key={malla.idMalla} fontSize="sm">
                      {malla.tipoMalla}
                    </Text>
                  ))}
                </FormControl>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Tipo Arena</FormLabel>
                  {seleccionado.mallas?.map((malla) => (
                    <Text fontSize="sm" key={malla.idMalla}>
                      {malla.tipoArenaMalla === "seca" && "Seca"}
                      {malla.tipoArenaMalla === "humeda" && "Humeda"}
                    </Text>
                  ))}
                </FormControl>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">
                    Target Standby Pozo
                  </FormLabel>
                  <Text fontSize="sm">
                    {seleccionado.targeStandbyPozoGral} mins
                  </Text>
                </FormControl>
              </HStack>
              <HStack pb={1}>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Tns. Arena/SC</FormLabel>
                  {seleccionado.mallas?.map((malla) => (
                    <Text key={malla.idMalla} fontSize="sm">
                      {malla.tnsArenaSc}
                    </Text>
                  ))}
                </FormControl>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Sandcube/Etapa</FormLabel>
                  {seleccionado.mallas?.map((malla) => (
                    <Text key={malla.idMalla} fontSize="sm">
                      {malla.scEtapas}
                    </Text>
                  ))}
                </FormControl>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">
                    Target tns por día
                  </FormLabel>
                  {seleccionado.mallas?.map((malla) => (
                    <Text fontSize="sm" key={malla.idMalla}>
                      {malla.targetTnsDiaM}
                    </Text>
                  ))}
                </FormControl>
              </HStack>
              <HStack py={1}>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Toneladas Total</FormLabel>
                  <Text fontSize="sm">{seleccionado.totalTns}</Text>
                </FormControl>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Etapas total/pad</FormLabel>
                  <Text fontSize="sm">{handleEtapas(seleccionado)}</Text>
                </FormControl>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Cantidad camiones</FormLabel>
                  <Text fontSize="sm">{seleccionado.camiones?.length}</Text>
                </FormControl>
              </HStack>
              <HStack>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Etapas por día</FormLabel>
                  <Text fontSize="sm">{seleccionado.etapasDiaMalla}</Text>
                </FormControl>
              </HStack>
              <Divider py={1} />
              {seleccionado.detallePlantas?.map((elemento, index) => (
                <Stack py={2} key={elemento.nombre} spacing={3}>
                  <HStack pt={1}>
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        Planta {index + 1}
                      </FormLabel>
                      <Text fontSize="sm">{elemento.nombrePlanta}</Text>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        Target IDA Pozo-Planta
                      </FormLabel>
                      <Text fontSize="sm">
                        {elemento.targetIdaPozoPlanta} mins
                      </Text>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        Target VUELTA Pozo-Planta
                      </FormLabel>
                      <Text fontSize="sm">
                        {elemento.targetVueltaPozoPlanta} mins
                      </Text>
                    </FormControl>
                  </HStack>
                  <HStack pt={1}>
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        Target Standby
                      </FormLabel>
                      <Text fontSize="sm">{elemento.targetStandBy} mins</Text>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        Target Vuelta completa
                      </FormLabel>
                      <Text fontSize="sm">
                        {elemento.targetVueltaCompleta} mins
                      </Text>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold">Target VCD</FormLabel>
                      <Text fontSize="sm">{elemento.targetVCD}</Text>
                    </FormControl>
                  </HStack>
                  <HStack pt={1}>
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        Target Tns. por día
                      </FormLabel>
                      <Text fontSize="sm">{elemento.targetTnsDiaPlanta}</Text>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        Standby del Camion
                      </FormLabel>
                      <Text fontSize="sm">{elemento.standByCamion} mins</Text>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold"></FormLabel>
                      <Text fontSize="sm"></Text>
                    </FormControl>
                  </HStack>
                </Stack>
              ))}
              <Divider py={1} />
              <HStack pt={2} pb={3}>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Set Asignado</FormLabel>
                  <Text fontSize="sm">
                    {seleccionado.idSET
                      ? handleSets(seleccionado.idSET)
                      : "Sin asignar"}
                  </Text>
                </FormControl>
                <FormControl alignSelf="start">
                  {seleccionado.dosificadora && (
                    <>
                      <FormLabel fontWeight="semibold">Dosificadora</FormLabel>
                      <Text fontSize="sm">
                        {seleccionado.dosificadora.nombreDosificadora}
                      </Text>
                    </>
                  )}
                </FormControl>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold"></FormLabel>
                  <Text fontSize="sm"></Text>
                </FormControl>
              </HStack>
              <HStack py={1} pb={3}>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Sandcubes</FormLabel>
                  <Text fontSize="sm">{seleccionado.SandCubes}</Text>
                </FormControl>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">SandVan</FormLabel>
                  <Text fontSize="sm">
                    {seleccionado.sandvan?.codigoSandVan}
                  </Text>
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="semibold">Sanders</FormLabel>
                  <Text fontSize="sm">
                    {seleccionado.sanderPrincipal?.codigoSander}
                  </Text>
                  {seleccionado.sanderBackup && (
                    <Text fontSize="sm">
                      {seleccionado.sanderBackup.codigoSander}
                    </Text>
                  )}
                </FormControl>
              </HStack>
              <HStack pb={1}>
                <FormControl alignSelf="start">
                  <FormLabel fontWeight="semibold">Autoelevadores</FormLabel>
                  <Text fontSize="sm">
                    {seleccionado.autoelevador1?.nombreAutoE}
                  </Text>
                  {seleccionado.autoelevador2 && (
                    <Text fontSize="sm">
                      {seleccionado.autoelevador2?.nombreAutoE}
                    </Text>
                  )}
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="semibold">Camiones</FormLabel>
                  {seleccionado.camiones
                    ?.sort((a) => (a.camionActivo === "false" ? 1 : -1))
                    .map((e) => (
                      <Text
                        fontSize="sm"
                        key={e.dominio}
                        color={e.camionActivo === "false" ? "red" : "inherit"}
                      >
                        {`${e.nombreCamion ? `${e.nombreCamion}` : ""}${
                          e.dominio ? ` - ${e.dominio}` : ""
                        }${e.nombreEmpresaT ? ` - ${e.nombreEmpresaT}` : ""}`}
                      </Text>
                    ))}
                </FormControl>
              </HStack>
            </CardBody>
            <Divider color="#EBEAEA" />
            <CardFooter justifyContent="space-between">
              {(user.idRol !== "cliente" || user.idRol !== "usuarioBrent") && (
                <Button
                  variant="outline"
                  border="1px solid #FF8200"
                  leftIcon={<MdOutlineGetApp fontSize="20px" />}
                  size="sm"
                  fontWeight="semibold"
                  fontSize={12}
                  letterSpacing={1}
                  color={"brand.naranja"}
                  onClick={() => handleDownload(seleccionado)}
                  _hover={{ bg: "brand.naranja", color: "white" }}
                >
                  Descargar
                </Button>
              )}
            </CardFooter>
          </Card>
        )}
        {!seleccionado && (
          <Center w={"40%"} justifyContent={"center"}>
            <Text
              fontSize={"14px"}
              color={"gray.400"}
              fontWeight={"bold"}
              textAlign={"center"}
            >
              La información se verá una vez <br /> que se seleccione una
              planificación
            </Text>
          </Center>
        )}
      </HStack>
    </VStack>
  );
};

export default Historial;
